import { render, staticRenderFns } from "./trawl-change-roles.vue?vue&type=template&id=788ef42a"
import script from "./trawl-change-roles.vue?vue&type=script&lang=js"
export * from "./trawl-change-roles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports